import { IMixpanelAnalysis } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const mixpanel: IMixpanelAnalysis = __WEB__ ? require('./web').default : require('./native').default;

export default mixpanel;
